import { externalProductPestPacName } from '@sales-center/common'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../userSlice'

export function useGetLocationUrl(externalLinkId: string, isBillTo: boolean) {
  const { externalProduct, clientUrl } = useSelector(selectCurrentUser)

  switch (externalProduct) {
    case externalProductPestPacName:
      return isBillTo
        ? `${clientUrl}/billto/edit.asp?Mode=Edit&BillToId=${externalLinkId}`
        : `${clientUrl}/location/detail.asp?LocationID=${externalLinkId}`
    default:
      return ''
  }
}
